import React from 'react';
import SelectFix from './_SelectFix';
import PopUpOther from './_PopUpOther';
import DataConfig from './../_config.json';
import { OnGetJsoni } from '../_getjson';
import Alert from 'react-s-alert';
import SelectFixdate from './../PopUp/SelectFix';
require('./stylemain.css');
const mFormat = 2;
export default class _tab_1 extends React.Component {
    state = {
        group: "",
        typeproduct: "",
        brandname: "",
        model: "",
        grade: "",
        color: "",
        price: "",
        accountgroup: "",
        serialNumber: "",
        usability: "",
        taxcalculation: "",
        costtype: "",
        category: "",
        sellminus: "",
        sticker: "",
        shortname: "",
        provincialregister: "",
        cash: "",
        changedata: false,
        cahsPrice: "",
        dnSum: "",
        dnMoney: "",
        periodPrice: "",
        period: "",
        producedby: "",
        rn_regist: "",
        dateRegist: "",
    }
    componentDidMount() {
        this.refs.group.value = "";
        this.refs.grade.value = "";
    }
    SelectSetData = (type, data) => {
        switch (type) {
            case "serialNumber":
                this.setState({
                    serialNumber: this._spritData(data)[0]
                });
                this.refs.serialNumber.value = this._spritData(data)[1];
                break;
            case "usability":
                this.setState({
                    usability: this._spritData(data)[0]
                });
                this.refs.usability.value = this._spritData(data)[1];
                break;
            case "taxcalculation":
                this.setState({
                    taxcalculation: this._spritData(data)[0]
                });
                this.refs.taxcalculation.value = this._spritData(data)[1];
                break;
            case "costtype":
                this.setState({
                    costtype: this._spritData(data)[0]
                });
                this.refs.costtype.value = this._spritData(data)[1];
                break;
            case "category":
                this.setState({
                    category: this._spritData(data)[0]
                });
                this.refs.category.value = this._spritData(data)[1];
                break;
            case "sellminus":
                this.setState({
                    sellminus: this._spritData(data)[0]
                });
                this.refs.sellminus.value = this._spritData(data)[1];
                break;
            case "group":
                this.setState({
                    group: this._spritData(data)[0]
                });
                this.refs.group.value = this._spritData(data)[1];
                break;
            case "grade":
                this.setState({
                    grade: this._spritData(data)[0]
                });
                this.refs.grade.value = this._spritData(data)[1];
                break;
            case "accountgroup":
                this.setState({
                    accountgroup: this._spritData(data)[0]
                });
                this.refs.accountgroup.value = this._spritData(data)[1];
                break;
            case "sticker":
                this.setState({
                    sticker: this._spritData(data)[0]
                });
                this.refs.sticker.value = this._spritData(data)[1];
                break;
            case "dateRegist": this.refs.dateRegist.value = data; break;
        }
        setTimeout(() => {
            this.props.Getdata("datatab", this.state);
        }, 50);
    }
    //************************************************************************sprit*************************************************************************************** */
    _spritData(data) {
        var str = data.split("|");
        return str;
    }
    //**************************************************************************popup**************************************************************************************/
    SetPopup = (data) => {
        this.setState({
            PopUpTYpe: data
        });
        this.setState({
            showPopupOT: !this.state.showPopupOT
        });
    }
    Get_PopUpOther = (data) => {
        switch (this.state.PopUpTYpe) {
            case "typeproduct":
                console.log(this._spritData(data)[1]);
                this.setState({
                    typeproduct: this._spritData(data)[0]
                });
                this.refs.typeproduct.value = this._spritData(data)[1];
                break;

            case "brandname":
                this.setState({
                    brandname: this._spritData(data)[0]
                });

                this.refs.brandname.value = this._spritData(data)[1];

                break;
            case "model":
                this.setState({
                    model: this._spritData(data)[0]
                });
                try {
                    this.refs.model.value = this._spritData(data)[1];
                } catch (error) {
                    console.log(error);
                }
                break;

            case "color":
                this.setState({
                    color: this._spritData(data)[0]
                });
                this.refs.color.value = this._spritData(data)[1];
                break;

            case "accountgroup":
                this.setState({
                    accountgroup: this._spritData(data)[0]
                });
                this.refs.accountgroup.value = this._spritData(data)[1];
                break;

            case "shortname":
                this.setState({
                    shortname: this._spritData(data)[0]
                });
                this.refs.shortname.value = this._spritData(data)[1];
                break;

            case "provincialregister":
                this.setState({
                    provincialregister: this._spritData(data)[0]
                });
                this.refs.provincialregister.value = this._spritData(data)[1];
                break;
            case "cash":
                this.setState({
                    cash: this._spritData(data)[0]
                });
                this.refs.cash.value = this._spritData(data)[1];
                break;
        }
        this.setState({
            showPopupOT: !this.state.showPopupOT
        });
        setTimeout(() => {
            this.props.Getdata("datatab", this.state);
        }, 50);

    }
    PopUpOtherClose = (data) => {
        this.setState({
            showPopupOT: !this.state.showPopupOT
        });
    }
    //****************************************************************************************************************************************************************/

    _alertPopup = (type, text) => {
        switch (type) {
            case 'Warning':
                Alert.warning(text, {
                    position: 'bottom-right',
                    effect: 'slide',
                    onShow: function () { },
                    beep: false,
                    timeout: 2000,
                    offset: 0
                });
                break;
            case 'Info':
                Alert.info(text, {
                    position: 'bottom-right',
                    effect: 'slide',
                    onShow: function () { },
                    beep: false,
                    timeout: 2000,
                    offset: 0
                });
                break;
            case 'Error':
                Alert.error(text, {
                    position: 'bottom-right',
                    effect: 'slide',
                    onShow: function () { },
                    beep: false,
                    timeout: 2000,
                    offset: 0
                });
                break;
            case 'Success':
                Alert.success(text, {
                    position: 'bottom-right',
                    effect: 'slide',
                    onShow: function () { },
                    beep: false,
                    timeout: 2000,
                    offset: 0
                });
                break;
            default:
                Alert.closeAll();
                break;
        }
    }
    _onKeyPressValue = (event) => {
        if (event.key === 'Enter') {

        }
    }
    // }
    handleBlur = (event) => {
        if (event.target.value !== "") {
            this._chkData(event.target.id, event.target.value);
        }
    }
    _chkData = (e, v) => {
        switch (e) {
            case 'group':
                var url = "CSPDMAINGROUP/ByCode?code=" + v;
                //   let typeGROUP=[];
                OnGetJsoni(url, 'group').then(data => {
                    if (data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            this.refs.group.value = data[i].MYNAMETH;
                            this.setState({
                                group: data[i].CODE
                            });
                        }
                    } else {
                        this._alertPopup("Error", "ไม่พบข้อมุล!");
                        this.refs.group.value = "";
                        this.refs.group.focus();
                        this.setState({
                            group: ""
                        });
                    }
                });
                break;
            case 'typeproduct':
                var url = "CSPDSUBGROUP1/ByCode?code=" + v;
                //   let typeGROUP=[];
                OnGetJsoni(url, 'typeproduct').then(data => {
                    if (data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            this.refs.typeproduct.value = data[i].MYNAMETH;
                            this.setState({
                                typeproduct: data[i].CODE
                            });
                        }
                    } else {
                        this._alertPopup("Error", "ไม่พบข้อมุล!");
                        this.refs.typeproduct.value = "";
                        this.refs.typeproduct.focus.value = "";
                        this.setState({
                            typeproduct: ""
                        });
                    }
                });
                break;

            case 'brandname':
                var url = "CSPDSUBGROUP2/ByCode?code=" + v;
                //   let typeGROUP=[];
                OnGetJsoni(url, 'brandname').then(data => {
                    if (data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            this.refs.brandname.value = data[i].MYNAMETH;
                            this.setState({
                                brandname: data[i].CODE
                            });
                        }
                    } else {
                        this._alertPopup("Error", "ไม่พบข้อมุล!");
                        this.refs.brandname.value = "";
                        this.refs.brandname.focus();
                        this.setState({
                            brandname: ""
                        });
                    }
                });
                break;

            case 'model':
                var url = "CSPDSUBGROUP3/ByCode?code=" + v;
                //   let typeGROUP=[];
                OnGetJsoni(url, 'model').then(data => {
                    if (data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            this.refs.model.value = data[i].MYNAMETH;
                            this.setState({
                                model: data[i].CODE
                            });
                        }
                    } else {
                        this._alertPopup("Error", "ไม่พบข้อมุล!");
                        this.refs.model.value = "";
                        this.refs.model.focus();
                        this.setState({
                            model: ""
                        });
                    }
                });
                break;

            case 'color':
                var url = "CSPDSUBGROUP4/ByCode?code=" + v;
                //   let typeGROUP=[];
                OnGetJsoni(url, 'color').then(data => {
                    if (data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            this.refs.color.value = data[i].MYNAMETH;
                            this.setState({
                                color: data[i].CODE
                            });
                        }
                    } else {
                        this._alertPopup("Error", "ไม่พบข้อมุล!");
                        this.refs.color.value = "";
                        this.refs.color.focus();
                        this.setState({
                            color: ""
                        });
                    }
                });
                break;

            case 'grade':
                var url = "CSPDSUBGROUP5/ByCode?code=" + v;
                //   let typeGROUP=[];
                OnGetJsoni(url, 'grade').then(data => {
                    if (data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            this.refs.grade.value = data[i].MYNAMETH;
                            this.setState({
                                grade: data[i].CODE
                            });
                        }
                    } else {
                        this._alertPopup("Error", "ไม่พบข้อมุล!");
                        this.refs.grade.value = "";
                        this.refs.grade.focus();
                        this.setState({
                            grade: ""
                        });
                    }
                });
                break;

            case 'shortname':
                var url = "CSDIMENSION1/ByCode?code=" + v;
                //   let typeGROUP=[];
                OnGetJsoni(url, 'shortname').then(data => {
                    if (data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            this.refs.shortname.value = data[i].MYNAMETH;
                            this.setState({
                                shortname: data[i].CODE
                            });
                        }
                    } else {
                        this._alertPopup("Error", "ไม่พบข้อมุล!");
                        this.refs.shortname.value = "";
                        this.refs.shortname.focus();
                        this.setState({
                            shortname: ""
                        });
                    }
                });
                break;

            case 'provincialregister':
                var url = "CSDIMENSION2/ByCode?code=" + v;
                //   let typeGROUP=[];
                OnGetJsoni(url, 'provincialregister').then(data => {
                    if (data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            this.refs.provincialregister.value = data[i].MYNAMETH;
                            this.setState({
                                provincialregister: data[i].CODE
                            });
                        }
                    } else {
                        this._alertPopup("Error", "ไม่พบข้อมุล!");
                        this.refs.provincialregister.value = "";
                        this.refs.provincialregister.focus();
                        this.setState({
                            provincialregister: ""
                        });
                    }
                });
                break;

            case 'cash':
                var url = "CSDIMENSION4/ByCode?code=" + v;
                //   let typeGROUP=[];
                OnGetJsoni(url, 'cash').then(data => {
                    if (data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            this.refs.cash.value = data[i].MYNAMETH;
                            this.setState({
                                cash: data[i].CODE
                            });
                        }
                    } else {
                        this._alertPopup("Error", "ไม่พบข้อมุล!");
                        this.refs.cash.value = "";
                        this.refs.cash.focus();
                        this.setState({
                            cash: ""
                        });
                    }
                });
                break;
            case 'accountgroup':
                var url = "CSPRODUCTACCGRP2/ByCode?code=" + v;
                //   let typeGROUP=[];
                OnGetJsoni(url, 'accountgroup').then(data => {
                    if (data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            this.refs.accountgroup.value = data[i].MYNAMETH;
                            this.setState({
                                accountgroup: data[i].CODE
                            });
                        }
                    } else {
                        this._alertPopup("Error", "ไม่พบข้อมุล!");
                        this.refs.accountgroup.value = "";
                        this.refs.accountgroup.focus();
                        this.setState({
                            accountgroup: ""
                        });
                    }
                });
                break;

        }
    }


    _onClick = (event) => {
        this._setDatatiinput(event);
    }

    _setDatatiinput = (event) => {
        switch (event.target.id) {
            case 'group':
                this.refs.group.value = this.state.group;
                break;
            case 'typeproduct':
                this.refs.typeproduct.value = this.state.typeproduct;
                break;
            case 'brandname':
                this.refs.brandname.value = this.state.brandname;
                break;
            case 'model':
                this.refs.model.value = this.state.model;
                break;
            case 'color':
                this.refs.color.value = this.state.color;
                break;
            case 'grade':
                this.refs.grade.value = this.state.grade;
                break;
            case 'shortname':
                this.refs.shortname.value = this.state.shortname;
                break;
            case 'provincialregister':
                this.refs.provincialregister.value = this.state.provincialregister;
                break;
            case 'cash':
                this.refs.cash.value = this.state.cash;
                break;
            case 'accountgroup':
                this.refs.accountgroup.value = this.state.accountgroup;
                break;
        }
    }
    _handleBlur = (event) => {
        switch (event.target.name) {
            case "cahsPrice":
                this.setState({ cahsPrice: parseFloat(event.target.value).toFixed(2) });
                this.refs.cahsPrice.value = parseFloat(this.refs.cahsPrice.value).toFixed(2);
                break;
            case "dnSum":
                this.setState({ dnSum: parseFloat(event.target.value).toFixed(mFormat) });
                this.refs.dnSum.value = parseFloat(this.refs.dnSum.value).toFixed(mFormat);
                break;
            case "dnMoney":
                this.setState({ dnMoney: parseFloat(event.target.value).toFixed(mFormat) });
                this.refs.dnMoney.value = parseFloat(this.refs.dnMoney.value).toFixed(mFormat);
                break;
            case "periodPrice":
                this.setState({ periodPrice: parseFloat(event.target.value).toFixed(mFormat) });
                this.refs.periodPrice.value = parseFloat(this.refs.periodPrice.value).toFixed(mFormat);
                break;
            case "period":
                this.setState({ period: parseFloat(event.target.value).toFixed(mFormat) });
                this.refs.period.value = parseFloat(this.refs.period.value).toFixed(mFormat);
                break;
            case "producedby":
                this.setState({ producedby: event.target.value });
                break;
            case "rn_regist":
                this.setState({ rn_regist: event.target.value });
                break;
            case "dateRegist":
                this.setState({ dateRegist: parseFloat(event.target.value) });
                break;

        }
    }

    render() {
        return (
            <div class={this.props.Inventory.showResults === 0 ? '' : "InventoryHidden"}>
                {this.state.showPopupOT ? <PopUpOther closePopup={this.PopUpOtherClose} Get_PopUpOther={this.Get_PopUpOther} type={this.state.PopUpTYpe} Data={this.state.valuePopup} groupdata={this.state.group} apikeyData={DataConfig.API_KEY[localStorage.getItem("company")]} jwtData={localStorage.getItem("Token")} /> : null}
                <br>
                </br>
                <div class="container-fluid">
                    <div class='col-xs-12 col-sm-6 col-md-6 col-lg-4' >
                        <div class="row">
                            <div class="container-fluid">
                                <div class="form-group">
                                    <div class="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <span class="input-group-addon"> กลุ่ม : </span>

                                        {/* <ReactTooltip effect="solid" /> */}
                                        <input data-tip={this.state.group} id="group" name="group" type="text" class="form-control" tabIndex="4" onKeyDown={this._onKeyPressValue} ref="group" onBlur={this.handleBlur.bind(this)} onClick={this._onClick.bind(this)} />
                                        <span class="input-group-addon textIcon">
                                            <SelectFix type={"group"} SelectSetData={this.SelectSetData} className="fas fa-search" />
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <span class="input-group-addon"> ประเภท : </span>
                                        <input id="typeproduct" name="typeproduct" data-tip={this.state.typeproduct} type="text" class="form-control" tabIndex="5" ref="typeproduct" onBlur={this.handleBlur.bind(this)} onKeyDown={this._onKeyPressValue} onClick={this._onClick.bind(this)} />
                                        <span class="input-group-addon textIcon" onClick={this.SetPopup.bind(null, "typeproduct")}>
                                            <i class="fas fa-list-ul"></i>
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <span class="input-group-addon"> ยี่ห้อ : </span>
                                        <input id="brandname" name="brandname" type="text" data-tip={this.state.brandname} class="form-control" tabIndex="6" ref="brandname" onBlur={this.handleBlur.bind(this)} onKeyDown={this._onKeyPressValue} onClick={this._onClick.bind(this)} />
                                        <span class="input-group-addon textIcon" onClick={this.SetPopup.bind(null, "brandname")}>
                                            <i class="fas fa-list-ul"></i>
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <span class="input-group-addon"> รุ่น : </span>
                                        <input id="model" name="model" type="text" data-tip={this.state.model} class="form-control" tabIndex="7" ref="model" onBlur={this.handleBlur.bind(this)} onKeyDown={this._onKeyPressValue} onClick={this._onClick.bind(this)} />
                                        <span class="input-group-addon textIcon" onClick={this.SetPopup.bind(null, "model")}>
                                            <i class="fas fa-list-ul"></i>
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <span class="input-group-addon"> สี : </span>
                                        <input id="color" name="color" type="text" data-tip={this.state.color} class="form-control" tabIndex="8" ref="color" onBlur={this.handleBlur.bind(this)} onKeyDown={this._onKeyPressValue} onClick={this._onClick.bind(this)} />
                                        <span class="input-group-addon textIcon" onClick={this.SetPopup.bind(null, "color")}>
                                            <i class="fas fa-list-ul"></i>
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <span class="input-group-addon"> เกรด : </span>
                                        <input id="grade" name="grade" type="text" data-tip={this.state.grade} class="form-control" tabIndex="9" ref="grade" onBlur={this.handleBlur.bind(this)} onKeyDown={this._onKeyPressValue} onClick={this._onClick.bind(this)} />
                                        <span class="input-group-addon textIcon" >
                                            <SelectFix type={"grade"} SelectSetData={this.SelectSetData} className="fas fa-search" />
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class='col-xs-12 col-sm-6 col-md-6 col-lg-4' >
                        <div class="container-fluid">
                            <div class="row">
                                <div class="form-group">
                                    <div class="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <span class="input-group-addon"> ชื่อย่อสินค้า : </span>
                                        <input id="shortname" name="shortname" type="text" data-tip={this.state.shortname} class="form-control" tabIndex="10" ref="shortname" onBlur={this.handleBlur.bind(this)} onKeyDown={this._onKeyPressValue} onClick={this._onClick.bind(this)} />
                                        <span class="input-group-addon textIcon" onClick={this.SetPopup.bind(null, "shortname")}>
                                            <i class="fas fa-list-ul"></i>
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <span class="input-group-addon"> ทะเบียนจังหวัด : </span>
                                        <input id="provincialregister" name="provincialregister" type="text" data-tip={this.state.provincialregister} class="form-control" tabIndex="11" ref="provincialregister" onBlur={this.handleBlur.bind(this)} onKeyDown={this._onKeyPressValue} onClick={this._onClick.bind(this)} />
                                        <span class="input-group-addon textIcon" onClick={this.SetPopup.bind(null, "provincialregister")}>
                                            <i class="fas fa-list-ul"></i>
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <span class="input-group-addon"> สติ๊กเกอร์ : </span>
                                        <input id="sticker" name="sticker" type="text" class="form-control read-only" data-tip={this.state.sticker} tabIndex="12" ref="sticker" onBlur={this.handleBlur.bind(this)} onKeyDown={this._onKeyPressValue} readOnly />
                                        <span class="input-group-addon textIcon" >
                                            <SelectFix type={"sticker"} SelectSetData={this.SelectSetData} className="fas fa-search" />
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <span class="input-group-addon"> เงินสด : </span>
                                        <input id="cash" name="cash" type="text" class="form-control" data-tip={this.state.cash} tabIndex="13" ref="cash" onBlur={this.handleBlur.bind(this)} onKeyDown={this._onKeyPressValue} onClick={this._onClick.bind(this)} />
                                        <span class="input-group-addon textIcon" onClick={this.SetPopup.bind(null, "cash")}>
                                            <i class="fas fa-list-ul"></i>
                                        </span>

                                    </div>
                                </div>
                                <div class="clearfix"></div>
                                <div class="form-group">
                                    <div class="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <span class="input-group-addon"> การใช้งาน : </span>
                                        <input id="usability" name="usability" type="text" data-tip={this.state.usability} class="form-control read-only" tabIndex="14" ref="usability" onBlur={this.handleBlur.bind(this)} onKeyDown={this._onKeyPressValue} readOnly />
                                        <span class="input-group-addon textIcon" >
                                            <SelectFix type={"usability"} SelectSetData={this.SelectSetData} className="fas fa-search" />
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <span class="input-group-addon"> กลุ่มบัญชี : </span>
                                        <input id="accountgroup" name="accountgroup" type="text" data-tip={this.state.accountgroup} class="form-control" tabIndex="15" ref="accountgroup" onBlur={this.handleBlur.bind(this)} onKeyDown={this._onKeyPressValue} onClick={this._onClick.bind(this)} />
                                        <span class="input-group-addon textIcon" onClick={this.SetPopup.bind(null, "accountgroup")}>
                                            <i class="fas fa-list-ul"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class='col-xs-12 col-sm-6 col-md-6 col-lg-4' >
                        <div class="container-fluid">
                            <div class="row">
                                <div class="form-group">
                                    <div class="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <span class="input-group-addon"> Serial Number: </span>
                                        <input id="serialNumber" name="serialNumber" type="text" data-tip={this.state.serialNumber} class="form-control read-only" ref="serialNumber" tabIndex="16" onBlur={this.handleBlur.bind(this)} onKeyDown={this._onKeyPressValue} readOnly />
                                        <span class="input-group-addon textIcon" >
                                            <SelectFix type={"serialNumber"} SelectSetData={this.SelectSetData} className="fas fa-search" />
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <span class="input-group-addon"> ประเภทต้นทุน : </span>
                                        <input id="costtype" name="costtype" type="text" data-tip={this.state.costtype} class="form-control read-only" ref="costtype" tabIndex="17" onBlur={this.handleBlur.bind(this)} onKeyDown={this._onKeyPressValue} readOnly />
                                        <span class="input-group-addon textIcon" >
                                            <SelectFix type={"costtype"} SelectSetData={this.SelectSetData} className="fas fa-search" />
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <span class="input-group-addon"> การคำนวณภาษี : </span>
                                        <input id="taxcalculation" name="taxcalculation" type="text" data-tip={this.state.taxcalculation} class="form-control read-only" ref="taxcalculation" tabIndex="18" onBlur={this.handleBlur.bind(this)} onKeyDown={this._onKeyPressValue} readOnly />
                                        <span class="input-group-addon textIcon" >
                                            <SelectFix type={"taxcalculation"} SelectSetData={this.SelectSetData} className="fas fa-search" /></span>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <span class="input-group-addon"> ประเภทสินค้า : </span>
                                        <input id="category" name="category" type="text" data-tip={this.state.category} class="form-control read-only" ref="category" tabIndex="19" onBlur={this.handleBlur.bind(this)} onKeyDown={this._onKeyPressValue} readOnly />
                                        <span class="input-group-addon textIcon" > <SelectFix type={"category"} SelectSetData={this.SelectSetData} className="fas fa-search" /></span>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <span class="input-group-addon"> การขายติดลบ : </span>
                                        <input id="sellminus" name="sellminus" type="text" data-tip={this.state.sellminus} class="form-control read-only" ref="sellminus" tabIndex="20" onBlur={this.handleBlur.bind(this)} onKeyDown={this._onKeyPressValue} readOnly />
                                        <span class="input-group-addon textIcon"><SelectFix type={"sellminus"} SelectSetData={this.SelectSetData} className="fas fa-search" /></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                    <div class='col-xs-12 col-sm-6 col-md-6 col-lg-6'>
                        <div class="container-fluid">
                            <div class="row">
                                <div class="form-group">
                                    <div class="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <span class="input-group-addon"> ราคาเงินสด : </span>
                                        <input id="21" name="cahsPrice" type="number" class="form-control" autoFocus tabIndex="21" ref="cahsPrice" onBlur={this._handleBlur.bind(this)} />
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="input-group input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <span class="input-group-addon"> ราคารวมผ่อน : </span>
                                        <input id="22" name="dnSum" type="number" class="form-control" tabIndex="22" ref="dnSum" onBlur={this._handleBlur.bind(this)} />
                                    </div>
                                </div>


                                <div class="form-group">
                                    <div class="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <span class="input-group-addon"> เงินดาวน์: </span>
                                        <input id="23" name="dnMoney" type="number" class="form-control" tabIndex="23" ref="dnMoney" onBlur={this._handleBlur.bind(this)} />
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <span class="input-group-addon"> ค่างวด : </span>
                                        <input id="24" name="periodPrice" type="number" class="form-control" tabIndex="24" ref="periodPrice" onBlur={this._handleBlur.bind(this)} />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class='col-xs-12 col-sm-6 col-md-6 col-lg-6'>
                        <div class="container-fluid">
                            <div class="row">

                                <div class="form-group">
                                    <div class="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <span class="input-group-addon"> งวด : </span>
                                        <input id="25" name="period" type="number" class="form-control" tabIndex="25" ref="period" onBlur={this._handleBlur.bind(this)} />
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <span class="input-group-addon"> ผลิตโดย : </span>
                                        <input id="26" name="producedby" type="text" class="form-control" tabIndex="26" ref="Producedby" onBlur={this._handleBlur.bind(this)} />
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <span class="input-group-addon">ทะเบียน : </span>
                                        <input id="27" name="rn_regist" type="text" class="form-control" tabIndex="27" ref="rn_regist" onBlur={this._handleBlur.bind(this)} />
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <span class="input-group-addon"> วันที่จดทะเบียน : </span>
                                        <input id="28" name="dateRegist" type="text" class="form-control" tabIndex="28" ref="dateRegist" onBlur={this._handleBlur.bind(this)} />
                                        <span class="input-group-addon icon"><SelectFixdate type="dateRegist" SelectSetData={this.SelectSetData} /></span>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>


            </div>
        )
    }
} 